export default {
  red: '#DE3D15',
  orange: '#F6921E',
  yellow: '#F9EC31',
  green: '#83EE2F',
  blue: '#1EC2F6',

  purple1: '#2E2259',
  purple2: '#3D2F73',

  buttermilk: '#FFEFB1',

  gray1: '#333333',
  gray2: '#EBEBEB',

  white: '#FFFFFF',
};
